import { Text } from '@/ui/core/typography'
import { Marquee } from '@animatereactnative/marquee'

export const PeakSmileMarquee = () => {
	return (
		<Marquee
			style={{
				flex: 0,
				minHeight: 56,
				backgroundColor: '#B5F6AE',
				display: 'flex',
				justifyContent: 'center',
			}}
			spacing={1}
			speed={1}
		>
			<Text spacing="wide" className="px-2 min-w-[216px]" size="large">
				REACH PEAK SMILE
			</Text>
		</Marquee>
	)
}
